import React from "react";
import { HiCheck } from "react-icons/hi";

/* create checkmark icons */
export function CheckMark({ text }: { text: string }) {
  return (
    <div className="flex py-4">
      <div className="w-8 mr-5 text-green-600">
        <HiCheck />
      </div>
      {text}
    </div>
  );
}
